import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { vendorFields } from './common/vendorFields';
import { productFields, purchasedMaterialFields } from './common/productFields';
import { msg } from '@lingui/core/macro';
import {
  isBiologicalField,
  isSecondaryField,
  materialField,
  materialWeightField,
  applicationOfCascadingPrincipleField,
  orgRawMaterialField,
  sustainableSourcingSchemeField,
} from './common/consumerGoodsFields';
import {
  casNumberField,
  substanceOfConcernField,
  hazardClassField,
  euPrtrGroupField,
} from './common/substanceFields';
import { massUnitField } from './common/sharedFields';

export const consumerGoodsEcoinventMaterialMetadata = {
  displayName: msg({
    message: 'Purchased materials: Ecoinvent',
    context: 'Activity data schema name for purchased materials: Ecoinvent',
  }),
  fields: {
    ...coreFields,
    ...vendorFields,
    ...productFields,
    ...purchasedMaterialFields,
    application_of_cascading_principle: applicationOfCascadingPrincipleField,
    cas_number: casNumberField,
    eu_prtr_group: euPrtrGroupField,
    hazard_class: hazardClassField,
    is_biological: isBiologicalField,
    is_secondary: isSecondaryField,
    org_material: materialField,
    org_raw_material: orgRawMaterialField,
    quantity: materialWeightField,
    substance_of_concern: substanceOfConcernField,
    sustainable_sourcing_scheme: sustainableSourcingSchemeField,
    unit: massUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
